import localConfig from 'config/localConfig';

let healthPollTimeoutId: number = null;
let healthPollAttempts = 0;
let healthPollExhausted = false;

export const healthCheck = () =>
    new Promise<boolean>((resolve) => {
        fetch(localConfig.data.healthCheckURL, {})
            .then((response) => {
                resolve(response.ok);
            })
            .catch(() => {
                resolve(false);
            });
    });

export const resetHealthCheck = () => {
    clearTimeout(healthPollTimeoutId);
    healthPollTimeoutId = null;
    healthPollAttempts = 0;
    healthPollExhausted = false;
};

export const healthCheckIfNotExhausted = async () => {
    if (healthPollExhausted || healthPollTimeoutId !== null) {
        return false;
    }

    return healthCheck();
};

export const retryHealthCheck = (intervalMs: number, maxAttempts: number, backoffFactor: number, onRecovered: () => void) => {
    if (healthPollTimeoutId !== null || healthPollExhausted) {
        return;
    }

    const scheduleNext = () => {
        const backoffMs = intervalMs * backoffFactor ** healthPollAttempts;

        healthPollTimeoutId = window.setTimeout(async () => {
            healthPollAttempts += 1;

            const isHealthy = await healthCheck();

            if (isHealthy || healthPollAttempts >= maxAttempts) {
                healthPollExhausted = !isHealthy;
                healthPollTimeoutId = null;
                healthPollAttempts = 0;

                if (isHealthy) {
                    onRecovered();
                }

                return;
            }

            scheduleNext();
        }, backoffMs);
    };

    scheduleNext();
};
